// extracted by mini-css-extract-plugin
module.exports = {"item-inside":"index__item-inside__1Cxt2","item":"index__item__d6N0J"};